module.exports = __webpack_public_path__ + "img/featured.48db3cfd.jpg";